// Letters rotate by 17, digits by 7, and the address is spelled
// "local at domain dot tld". Decoding in plaintext would put the addresses
// back into the repository; see
// adr/0011-serve-the-contact-email-behind-a-redirect.md.
const ROTATE_ALPHA_OFFSET = 17;
const ROTATE_DIGIT_OFFSET = 7;

const rotateBackward = (
  code: number,
  base: number,
  length: number,
  offset: number,
) => String.fromCharCode(((code - base + length - offset) % length) + base);

const decodeRot17 = (value: string) =>
  value
    .replace(/[a-z]/g, (char) =>
      rotateBackward(char.charCodeAt(0), 97, 26, ROTATE_ALPHA_OFFSET),
    )
    .replace(/[A-Z]/g, (char) =>
      rotateBackward(char.charCodeAt(0), 65, 26, ROTATE_ALPHA_OFFSET),
    )
    .replace(/[0-9]/g, (char) =>
      rotateBackward(char.charCodeAt(0), 48, 10, ROTATE_DIGIT_OFFSET),
    );

export const decodeObfuscatedEmail = (encoded: string) =>
  decodeRot17(encoded.replace(" at ", "@").split(" dot ").join("."));
